import { ChangeSetType, CosmicDocumentStatus, DocumentReleaseStatus, DocumentType, EztDocumentType, FracasAnalysisStatus, FracasCauseOfFailure, FracasFailureEnvironment, FracasFailureMode, FracasFailurePhase, FracasFailureType, FracasScoring, FracasSubSystem, RcaRootCauseCategory } from '~/db_types';
import { DeliveryOrderLineItemStatus, DeliveryOrderLineItemType, DocumentRelationType, HistoryType, NonconformanceReportDefectType, SoftwareClass, TaskPerformanceSheetCriticality, TpsClosureStatus, TpsDocumentType, WorkOrderStepCompletionStatus } from '~/db_types/swagger_types';
export var CosmicManagedDocumentType;
(function (CosmicManagedDocumentType) {
    CosmicManagedDocumentType["C_NONCONFORMANCE_REPORT"] = "C_NONCONFORMANCE_REPORT";
    CosmicManagedDocumentType["C_EASY_TRANSFER"] = "C_EASY_TRANSFER";
    CosmicManagedDocumentType["C_FAILURE_REPORTING_ANALYSIS_CORRECTIVE_ACTION_SYSTEM"] = "C_FAILURE_REPORTING_ANALYSIS_CORRECTIVE_ACTION_SYSTEM";
    CosmicManagedDocumentType["C_RCA"] = "C_RCA";
    CosmicManagedDocumentType["C_TPS"] = "C_TPS";
    CosmicManagedDocumentType["C_WORKFLOW"] = "C_WORKFLOW";
})(CosmicManagedDocumentType || (CosmicManagedDocumentType = {}));
export var TrackingDocumentType;
(function (TrackingDocumentType) {
    TrackingDocumentType["ACCEPTANCE_DATA_PACK"] = "ACCEPTANCE_DATA_PACK";
    TrackingDocumentType["BARCODE_DECLARATION"] = "BARCODE_DECLARATION";
    TrackingDocumentType["CONFIGURATION_CHANGE_ORDER"] = "CONFIGURATION_CHANGE_ORDER";
    TrackingDocumentType["CR"] = "CR";
    TrackingDocumentType["DISCREPANCY_REPORT"] = "DISCREPANCY_REPORT";
    TrackingDocumentType["DRAWING"] = "DRAWING";
    TrackingDocumentType["EASY_TRANSFER"] = "EASY_TRANSFER";
    TrackingDocumentType["ELABEL"] = "ELABEL";
    TrackingDocumentType["ELROD"] = "ELROD";
    TrackingDocumentType["ENGINEERING_CHANGE"] = "ENGINEERING_CHANGE";
    TrackingDocumentType["FAILURE_INVESTIGATION_ANOMALY_REPORT"] = "FAILURE_INVESTIGATION_ANOMALY_REPORT";
    TrackingDocumentType["GCAR"] = "GCAR";
    TrackingDocumentType["HAZARD_RESPONSE_LEVEL"] = "HAZARD_RESPONSE_LEVEL";
    TrackingDocumentType["IRREGULAR_PARTS_AUTHORIZATION_REQUEST"] = "IRREGULAR_PARTS_AUTHORIZATION_REQUEST";
    TrackingDocumentType["ITEM_FOR_INVESTIGATION"] = "ITEM_FOR_INVESTIGATION";
    TrackingDocumentType["MATERIAL_USAGE_AGREEMENT"] = "MATERIAL_USAGE_AGREEMENT";
    TrackingDocumentType["NASA_SPACE_PART_AUTHORIZATION_REQUEST"] = "NASA_SPACE_PART_AUTHORIZATION_REQUEST";
    TrackingDocumentType["NINE_ZERO_SIX"] = "NINE_ZERO_SIX";
    TrackingDocumentType["OPS_NOM_DECLARATION"] = "OPS_NOM_DECLARATION";
    TrackingDocumentType["OTHER_DOCUMENT"] = "OTHER_DOCUMENT";
    TrackingDocumentType["OVER_DUE_TAG"] = "OVER_DUE_TAG";
    TrackingDocumentType["PROBLEM_REPORTING_AND_CORRECTIVE_ACTION"] = "PROBLEM_REPORTING_AND_CORRECTIVE_ACTION";
    TrackingDocumentType["PROCEDURE"] = "PROCEDURE";
    TrackingDocumentType["RSA"] = "RSA";
    TrackingDocumentType["TPS"] = "TPS";
    TrackingDocumentType["VEHICLE_CERTIFICATION"] = "VEHICLE_CERTIFICATION";
    TrackingDocumentType["WAIVER"] = "WAIVER";
    TrackingDocumentType["YELLOW_TAG_NOTICE"] = "YELLOW_TAG_NOTICE";
})(TrackingDocumentType || (TrackingDocumentType = {}));
export const CosmicManagedDocumentTypeDisplay = new Map([
    [CosmicManagedDocumentType.C_NONCONFORMANCE_REPORT, 'cNCR'],
    [CosmicManagedDocumentType.C_EASY_TRANSFER, 'cEZT'],
    [CosmicManagedDocumentType.C_FAILURE_REPORTING_ANALYSIS_CORRECTIVE_ACTION_SYSTEM, 'cFRACAS'],
    [CosmicManagedDocumentType.C_RCA, 'cRCA'],
    [CosmicManagedDocumentType.C_TPS, 'cTPS'],
    [CosmicManagedDocumentType.C_WORKFLOW, 'cWORKFLOW']
]);
// Used in the TpsDocumentStatus_____Icon components
export var TpsDocumentStatusIconState;
(function (TpsDocumentStatusIconState) {
    TpsDocumentStatusIconState["ACTIVE"] = "ACTIVE";
    TpsDocumentStatusIconState["COMPLETE"] = "COMPLETE";
    TpsDocumentStatusIconState["FUTURE"] = "FUTURE";
    TpsDocumentStatusIconState["REJECTED"] = "REJECTED";
})(TpsDocumentStatusIconState || (TpsDocumentStatusIconState = {}));
// Used in the NcrDocumentStatus_____Icon components
export var NcrDocumentStatusIconState;
(function (NcrDocumentStatusIconState) {
    NcrDocumentStatusIconState["ACTIVE"] = "ACTIVE";
    NcrDocumentStatusIconState["COMPLETE"] = "COMPLETE";
    NcrDocumentStatusIconState["FUTURE"] = "FUTURE";
    NcrDocumentStatusIconState["REJECTED"] = "REJECTED";
})(NcrDocumentStatusIconState || (NcrDocumentStatusIconState = {}));
export var SupportInitiative;
(function (SupportInitiative) {
    SupportInitiative["AES"] = "AES";
    SupportInitiative["C3PO"] = "C3PO";
    SupportInitiative["EHP"] = "EHP";
    SupportInitiative["GATEWAY"] = "GATEWAY";
    SupportInitiative["ISS"] = "ISS";
    SupportInitiative["MPCV"] = "MPCV";
    SupportInitiative["OCT"] = "OCT";
    SupportInitiative["SSP"] = "SSP";
    SupportInitiative["OTHER"] = "OTHER";
})(SupportInitiative || (SupportInitiative = {}));
export const SupportInitiativeDisplay = new Map([
    [SupportInitiative.AES, 'AES'],
    [SupportInitiative.C3PO, 'C3PO'],
    [SupportInitiative.EHP, 'EHP'],
    [SupportInitiative.GATEWAY, 'Gateway'],
    [SupportInitiative.ISS, 'ISS'],
    [SupportInitiative.MPCV, 'MPCV'],
    [SupportInitiative.OCT, 'OCT'],
    [SupportInitiative.OTHER, 'Other'],
    [SupportInitiative.SSP, 'SSP']
]);
export const SupportInitiativeDescriptionOnlyDisplay = new Map([
    [SupportInitiative.AES, 'Advanced Engineering Systems'],
    [SupportInitiative.C3PO, 'Commercial Crew and Cargo Program Office'],
    [SupportInitiative.EHP, 'Extravehicular Activity and Human Surface Mobility Program'],
    [SupportInitiative.GATEWAY, 'Gateway'],
    [SupportInitiative.ISS, 'International Space Station'],
    [SupportInitiative.MPCV, 'Multi-Purpose Crew Vehicle'],
    [SupportInitiative.OCT, 'Office of the Chief Technologist'],
    [SupportInitiative.OTHER, 'Other'],
    [SupportInitiative.SSP, 'Space Station Program']
]);
export const SoftwareClassDisplay = new Map([
    [SoftwareClass.CLASS_A, 'Class A'],
    [SoftwareClass.CLASS_B, 'Class B'],
    [SoftwareClass.CLASS_C_FLIGHT, 'Class C Flight'],
    [SoftwareClass.CLASS_C_GROUND, 'Class C Ground'],
    [SoftwareClass.CLASS_D, 'Class D']
]);
export var HardwareDefectTypeSubcategory;
(function (HardwareDefectTypeSubcategory) {
    HardwareDefectTypeSubcategory["MATERIAL_COMPONENT"] = "MATERIAL_COMPONENT";
    HardwareDefectTypeSubcategory["PHYSICAL_DAMAGE"] = "PHYSICAL_DAMAGE";
    HardwareDefectTypeSubcategory["ELECTRICAL_ELECTRONIC"] = "ELECTRICAL_ELECTRONIC";
    HardwareDefectTypeSubcategory["MANUFACTURING_PROCESS"] = "MANUFACTURING_PROCESS";
    HardwareDefectTypeSubcategory["DOCUMENTATION_PROCEDURAL"] = "DOCUMENTATION_PROCEDURAL";
    HardwareDefectTypeSubcategory["OTHER"] = "OTHER";
})(HardwareDefectTypeSubcategory || (HardwareDefectTypeSubcategory = {}));
export var SoftwareDefectTypeSubcategory;
(function (SoftwareDefectTypeSubcategory) {
    SoftwareDefectTypeSubcategory["SOFTWARE_SYSTEM"] = "SOFTWARE_SYSTEM";
    SoftwareDefectTypeSubcategory["CYBERSECURITY"] = "CYBERSECURITY";
    SoftwareDefectTypeSubcategory["OTHER"] = "OTHER";
})(SoftwareDefectTypeSubcategory || (SoftwareDefectTypeSubcategory = {}));
export var NonconformanceReportDefectTypeSubcategory;
(function (NonconformanceReportDefectTypeSubcategory) {
    NonconformanceReportDefectTypeSubcategory["CYBERSECURITY"] = "CYBERSECURITY";
    NonconformanceReportDefectTypeSubcategory["DOCUMENTATION_PROCEDURAL"] = "DOCUMENTATION_PROCEDURAL";
    NonconformanceReportDefectTypeSubcategory["ELECTRICAL_ELECTRONIC"] = "ELECTRICAL_ELECTRONIC";
    NonconformanceReportDefectTypeSubcategory["MANUFACTURING_PROCESS"] = "MANUFACTURING_PROCESS";
    NonconformanceReportDefectTypeSubcategory["MATERIAL_COMPONENT"] = "MATERIAL_COMPONENT";
    NonconformanceReportDefectTypeSubcategory["OTHER"] = "OTHER";
    NonconformanceReportDefectTypeSubcategory["PHYSICAL_DAMAGE"] = "PHYSICAL_DAMAGE";
    NonconformanceReportDefectTypeSubcategory["SOFTWARE_SYSTEM"] = "SOFTWARE_SYSTEM";
})(NonconformanceReportDefectTypeSubcategory || (NonconformanceReportDefectTypeSubcategory = {}));
export const HardwareDefectTypeSubcategoryDisplay = new Map([
    [HardwareDefectTypeSubcategory.MATERIAL_COMPONENT, 'Material / Component'],
    [HardwareDefectTypeSubcategory.PHYSICAL_DAMAGE, 'Physical damage'],
    [HardwareDefectTypeSubcategory.ELECTRICAL_ELECTRONIC, 'Electrical / Electronic'],
    [HardwareDefectTypeSubcategory.MANUFACTURING_PROCESS, 'Manufacturing process'],
    [HardwareDefectTypeSubcategory.DOCUMENTATION_PROCEDURAL, 'Documentation / Procedural'],
    [HardwareDefectTypeSubcategory.OTHER, 'Other']
]);
export const SoftwareDefectTypeSubcategoryDisplay = new Map([
    [SoftwareDefectTypeSubcategory.SOFTWARE_SYSTEM, 'Software / System'],
    [SoftwareDefectTypeSubcategory.CYBERSECURITY, 'Cybersecurity'],
    [SoftwareDefectTypeSubcategory.OTHER, 'Other']
]);
export const NonconformanceReportDefectTypeSubcategoryDisplay = new Map([
    [NonconformanceReportDefectTypeSubcategory.CYBERSECURITY, 'Cybersecurity'],
    [NonconformanceReportDefectTypeSubcategory.DOCUMENTATION_PROCEDURAL, 'Documentation / Procedural'],
    [NonconformanceReportDefectTypeSubcategory.ELECTRICAL_ELECTRONIC, 'Electrical / Electronic'],
    [NonconformanceReportDefectTypeSubcategory.MANUFACTURING_PROCESS, 'Manufacturing process'],
    [NonconformanceReportDefectTypeSubcategory.MATERIAL_COMPONENT, 'Material / Component'],
    [NonconformanceReportDefectTypeSubcategory.OTHER, 'Other'],
    [NonconformanceReportDefectTypeSubcategory.SOFTWARE_SYSTEM, 'Software / System'],
    [NonconformanceReportDefectTypeSubcategory.PHYSICAL_DAMAGE, 'Physical damage']
]);
export var HardwareNonconformanceReportDefectType;
(function (HardwareNonconformanceReportDefectType) {
    HardwareNonconformanceReportDefectType["CALIBRATION_ISSUES"] = "CALIBRATION_ISSUES";
    HardwareNonconformanceReportDefectType["COMPONENT_MISSING_INCORRECT"] = "COMPONENT_MISSING_INCORRECT";
    HardwareNonconformanceReportDefectType["DIMENSIONAL_FIT_ISSUES"] = "DIMENSIONAL_FIT_ISSUES";
    HardwareNonconformanceReportDefectType["DOCUMENTATION_APPROVAL_ISSUES"] = "DOCUMENTATION_APPROVAL_ISSUES";
    HardwareNonconformanceReportDefectType["ELECTRICAL_ASSEMBLY_ISSUES"] = "ELECTRICAL_ASSEMBLY_ISSUES";
    HardwareNonconformanceReportDefectType["ELECTRICAL_COMPONENT_DEFECTS"] = "ELECTRICAL_COMPONENT_DEFECTS";
    HardwareNonconformanceReportDefectType["ELECTRICAL_PERFORMANCE"] = "ELECTRICAL_PERFORMANCE";
    HardwareNonconformanceReportDefectType["FOREIGN_OBJECT_DEBRIS_CONTAMINATION"] = "FOREIGN_OBJECT_DEBRIS_CONTAMINATION";
    HardwareNonconformanceReportDefectType["MATERIAL_CERTIFICATION_ISSUES"] = "MATERIAL_CERTIFICATION_ISSUES";
    HardwareNonconformanceReportDefectType["MATERIAL_PROPERTIES"] = "MATERIAL_PROPERTIES";
    HardwareNonconformanceReportDefectType["NO_DEFECT_CLASSIFICATION_CHANGE"] = "NO_DEFECT_CLASSIFICATION_CHANGE";
    HardwareNonconformanceReportDefectType["PROCESS_NON_COMPLIANCE"] = "PROCESS_NON_COMPLIANCE";
    HardwareNonconformanceReportDefectType["SAFETY_COMPLIANCE"] = "SAFETY_COMPLIANCE";
    HardwareNonconformanceReportDefectType["STRUCTURAL_DAMAGE"] = "STRUCTURAL_DAMAGE";
    HardwareNonconformanceReportDefectType["SURFACE_COATING_DEFECTS"] = "SURFACE_COATING_DEFECTS";
    HardwareNonconformanceReportDefectType["UNKNOWN_UNEXPLAINED_ANOMALY"] = "UNKNOWN_UNEXPLAINED_ANOMALY";
    HardwareNonconformanceReportDefectType["WORKMANSHIP_DEFECTS"] = "WORKMANSHIP_DEFECTS";
})(HardwareNonconformanceReportDefectType || (HardwareNonconformanceReportDefectType = {}));
export var SoftwareNonconformanceReportDefectType;
(function (SoftwareNonconformanceReportDefectType) {
    SoftwareNonconformanceReportDefectType["ANTIVIRUS_SECURITY_DEFINITION_ISSUES"] = "ANTIVIRUS_SECURITY_DEFINITION_ISSUES";
    SoftwareNonconformanceReportDefectType["MALWARE_VIRUS_DETECTION"] = "MALWARE_VIRUS_DETECTION";
    SoftwareNonconformanceReportDefectType["NO_DEFECT_CLASSIFICATION_CHANGE"] = "NO_DEFECT_CLASSIFICATION_CHANGE";
    SoftwareNonconformanceReportDefectType["SECURITY_PLAN_PROCESS_VIOLATIONS"] = "SECURITY_PLAN_PROCESS_VIOLATIONS";
    SoftwareNonconformanceReportDefectType["SECURITY_VULNERABILITY_RISK_ISSUES"] = "SECURITY_VULNERABILITY_RISK_ISSUES";
    SoftwareNonconformanceReportDefectType["SOFTWARE_CODE_PERFORMANCE_DEFECTS"] = "SOFTWARE_CODE_PERFORMANCE_DEFECTS";
    SoftwareNonconformanceReportDefectType["SOFTWARE_CONFIGURATION_ISSUES"] = "SOFTWARE_CONFIGURATION_ISSUES";
    SoftwareNonconformanceReportDefectType["SYSTEM_INTEGRATION_ISSUES"] = "SYSTEM_INTEGRATION_ISSUES";
    SoftwareNonconformanceReportDefectType["THIRD_PARTY_SOFTWARE_ISSUES"] = "THIRD_PARTY_SOFTWARE_ISSUES";
    SoftwareNonconformanceReportDefectType["UNAUTHORIZED_SOFTWARE_DATA_INSTALLATION"] = "UNAUTHORIZED_SOFTWARE_DATA_INSTALLATION";
    SoftwareNonconformanceReportDefectType["UNKNOWN_UNEXPLAINED_ANOMALY"] = "UNKNOWN_UNEXPLAINED_ANOMALY";
    SoftwareNonconformanceReportDefectType["WORKMANSHIP_UNINTENTIONAL_SYSTEM_RESET_REBOOT"] = "WORKMANSHIP_UNINTENTIONAL_SYSTEM_RESET_REBOOT";
})(SoftwareNonconformanceReportDefectType || (SoftwareNonconformanceReportDefectType = {}));
export const NonconformanceReportDefectTypeSubcategoryMapper = new Map([
    [NonconformanceReportDefectType.MATERIAL_PROPERTIES, [NonconformanceReportDefectTypeSubcategory.MATERIAL_COMPONENT]],
    [
        NonconformanceReportDefectType.COMPONENT_MISSING_INCORRECT,
        [NonconformanceReportDefectTypeSubcategory.MATERIAL_COMPONENT]
    ],
    [
        NonconformanceReportDefectType.MATERIAL_CERTIFICATION_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.MATERIAL_COMPONENT]
    ],
    [NonconformanceReportDefectType.STRUCTURAL_DAMAGE, [NonconformanceReportDefectTypeSubcategory.PHYSICAL_DAMAGE]],
    [NonconformanceReportDefectType.SURFACE_COATING_DEFECTS, [NonconformanceReportDefectTypeSubcategory.PHYSICAL_DAMAGE]],
    [NonconformanceReportDefectType.DIMENSIONAL_FIT_ISSUES, [NonconformanceReportDefectTypeSubcategory.PHYSICAL_DAMAGE]],
    [
        NonconformanceReportDefectType.ELECTRICAL_COMPONENT_DEFECTS,
        [NonconformanceReportDefectTypeSubcategory.ELECTRICAL_ELECTRONIC]
    ],
    [
        NonconformanceReportDefectType.ELECTRICAL_ASSEMBLY_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.ELECTRICAL_ELECTRONIC]
    ],
    [
        NonconformanceReportDefectType.ELECTRICAL_PERFORMANCE,
        [NonconformanceReportDefectTypeSubcategory.ELECTRICAL_ELECTRONIC]
    ],
    [
        NonconformanceReportDefectType.WORKMANSHIP_DEFECTS,
        [NonconformanceReportDefectTypeSubcategory.MANUFACTURING_PROCESS]
    ],
    [
        NonconformanceReportDefectType.PROCESS_NON_COMPLIANCE,
        [NonconformanceReportDefectTypeSubcategory.MANUFACTURING_PROCESS]
    ],
    [
        NonconformanceReportDefectType.FOREIGN_OBJECT_DEBRIS_CONTAMINATION,
        [NonconformanceReportDefectTypeSubcategory.MANUFACTURING_PROCESS]
    ],
    [
        NonconformanceReportDefectType.CALIBRATION_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.DOCUMENTATION_PROCEDURAL]
    ],
    [
        NonconformanceReportDefectType.SAFETY_COMPLIANCE,
        [NonconformanceReportDefectTypeSubcategory.DOCUMENTATION_PROCEDURAL]
    ],
    [
        NonconformanceReportDefectType.DOCUMENTATION_APPROVAL_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.DOCUMENTATION_PROCEDURAL]
    ],
    [NonconformanceReportDefectType.UNKNOWN_UNEXPLAINED_ANOMALY, [NonconformanceReportDefectTypeSubcategory.OTHER]],
    [NonconformanceReportDefectType.NO_DEFECT_CLASSIFICATION_CHANGE, [NonconformanceReportDefectTypeSubcategory.OTHER]],
    [
        NonconformanceReportDefectType.SOFTWARE_CONFIGURATION_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.SOFTWARE_SYSTEM]
    ],
    [
        NonconformanceReportDefectType.SOFTWARE_CODE_PERFORMANCE_DEFECTS,
        [NonconformanceReportDefectTypeSubcategory.SOFTWARE_SYSTEM]
    ],
    [
        NonconformanceReportDefectType.SYSTEM_INTEGRATION_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.SOFTWARE_SYSTEM]
    ],
    [
        NonconformanceReportDefectType.THIRD_PARTY_SOFTWARE_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.SOFTWARE_SYSTEM]
    ],
    [
        NonconformanceReportDefectType.UNAUTHORIZED_SOFTWARE_DATA_INSTALLATION,
        [NonconformanceReportDefectTypeSubcategory.SOFTWARE_SYSTEM]
    ],
    [
        NonconformanceReportDefectType.ANTIVIRUS_SECURITY_DEFINITION_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.CYBERSECURITY]
    ],
    [NonconformanceReportDefectType.MALWARE_VIRUS_DETECTION, [NonconformanceReportDefectTypeSubcategory.CYBERSECURITY]],
    [
        NonconformanceReportDefectType.SECURITY_PLAN_PROCESS_VIOLATIONS,
        [NonconformanceReportDefectTypeSubcategory.CYBERSECURITY]
    ],
    [
        NonconformanceReportDefectType.SECURITY_VULNERABILITY_RISK_ISSUES,
        [NonconformanceReportDefectTypeSubcategory.CYBERSECURITY]
    ],
    [
        NonconformanceReportDefectType.WORKMANSHIP_UNINTENTIONAL_SYSTEM_RESET_REBOOT,
        [NonconformanceReportDefectTypeSubcategory.OTHER]
    ]
]);
export const HardwareDefectTypeSubcategoryMapper = new Map([
    [HardwareNonconformanceReportDefectType.MATERIAL_PROPERTIES, [HardwareDefectTypeSubcategory.MATERIAL_COMPONENT]],
    [
        HardwareNonconformanceReportDefectType.COMPONENT_MISSING_INCORRECT,
        [HardwareDefectTypeSubcategory.MATERIAL_COMPONENT]
    ],
    [
        HardwareNonconformanceReportDefectType.MATERIAL_CERTIFICATION_ISSUES,
        [HardwareDefectTypeSubcategory.MATERIAL_COMPONENT]
    ],
    [HardwareNonconformanceReportDefectType.STRUCTURAL_DAMAGE, [HardwareDefectTypeSubcategory.PHYSICAL_DAMAGE]],
    [HardwareNonconformanceReportDefectType.SURFACE_COATING_DEFECTS, [HardwareDefectTypeSubcategory.PHYSICAL_DAMAGE]],
    [HardwareNonconformanceReportDefectType.DIMENSIONAL_FIT_ISSUES, [HardwareDefectTypeSubcategory.PHYSICAL_DAMAGE]],
    [
        HardwareNonconformanceReportDefectType.ELECTRICAL_COMPONENT_DEFECTS,
        [HardwareDefectTypeSubcategory.ELECTRICAL_ELECTRONIC]
    ],
    [
        HardwareNonconformanceReportDefectType.ELECTRICAL_ASSEMBLY_ISSUES,
        [HardwareDefectTypeSubcategory.ELECTRICAL_ELECTRONIC]
    ],
    [
        HardwareNonconformanceReportDefectType.ELECTRICAL_PERFORMANCE,
        [HardwareDefectTypeSubcategory.ELECTRICAL_ELECTRONIC]
    ],
    [HardwareNonconformanceReportDefectType.WORKMANSHIP_DEFECTS, [HardwareDefectTypeSubcategory.MANUFACTURING_PROCESS]],
    [
        HardwareNonconformanceReportDefectType.PROCESS_NON_COMPLIANCE,
        [HardwareDefectTypeSubcategory.MANUFACTURING_PROCESS]
    ],
    [
        HardwareNonconformanceReportDefectType.FOREIGN_OBJECT_DEBRIS_CONTAMINATION,
        [HardwareDefectTypeSubcategory.MANUFACTURING_PROCESS]
    ],
    [HardwareNonconformanceReportDefectType.CALIBRATION_ISSUES, [HardwareDefectTypeSubcategory.DOCUMENTATION_PROCEDURAL]],
    [HardwareNonconformanceReportDefectType.SAFETY_COMPLIANCE, [HardwareDefectTypeSubcategory.DOCUMENTATION_PROCEDURAL]],
    [
        HardwareNonconformanceReportDefectType.DOCUMENTATION_APPROVAL_ISSUES,
        [HardwareDefectTypeSubcategory.DOCUMENTATION_PROCEDURAL]
    ],
    [HardwareNonconformanceReportDefectType.UNKNOWN_UNEXPLAINED_ANOMALY, [HardwareDefectTypeSubcategory.OTHER]],
    [HardwareNonconformanceReportDefectType.NO_DEFECT_CLASSIFICATION_CHANGE, [HardwareDefectTypeSubcategory.OTHER]]
]);
export const SoftwareDefectTypeSubcategoryMapper = new Map([
    [
        SoftwareNonconformanceReportDefectType.SOFTWARE_CONFIGURATION_ISSUES,
        [SoftwareDefectTypeSubcategory.SOFTWARE_SYSTEM]
    ],
    [
        SoftwareNonconformanceReportDefectType.SOFTWARE_CODE_PERFORMANCE_DEFECTS,
        [SoftwareDefectTypeSubcategory.SOFTWARE_SYSTEM]
    ],
    [SoftwareNonconformanceReportDefectType.SYSTEM_INTEGRATION_ISSUES, [SoftwareDefectTypeSubcategory.SOFTWARE_SYSTEM]],
    [SoftwareNonconformanceReportDefectType.THIRD_PARTY_SOFTWARE_ISSUES, [SoftwareDefectTypeSubcategory.SOFTWARE_SYSTEM]],
    [
        SoftwareNonconformanceReportDefectType.UNAUTHORIZED_SOFTWARE_DATA_INSTALLATION,
        [SoftwareDefectTypeSubcategory.SOFTWARE_SYSTEM]
    ],
    [
        SoftwareNonconformanceReportDefectType.ANTIVIRUS_SECURITY_DEFINITION_ISSUES,
        [SoftwareDefectTypeSubcategory.CYBERSECURITY]
    ],
    [SoftwareNonconformanceReportDefectType.MALWARE_VIRUS_DETECTION, [SoftwareDefectTypeSubcategory.CYBERSECURITY]],
    [
        SoftwareNonconformanceReportDefectType.SECURITY_PLAN_PROCESS_VIOLATIONS,
        [SoftwareDefectTypeSubcategory.CYBERSECURITY]
    ],
    [
        SoftwareNonconformanceReportDefectType.SECURITY_VULNERABILITY_RISK_ISSUES,
        [SoftwareDefectTypeSubcategory.CYBERSECURITY]
    ],
    [SoftwareNonconformanceReportDefectType.UNKNOWN_UNEXPLAINED_ANOMALY, [SoftwareDefectTypeSubcategory.OTHER]],
    [SoftwareNonconformanceReportDefectType.NO_DEFECT_CLASSIFICATION_CHANGE, [SoftwareDefectTypeSubcategory.OTHER]],
    [
        SoftwareNonconformanceReportDefectType.WORKMANSHIP_UNINTENTIONAL_SYSTEM_RESET_REBOOT,
        [SoftwareDefectTypeSubcategory.OTHER]
    ]
]);
// used to test whether a given ChangeSetType is one used in exclusively in cDocs. example:
// cDocsChangeSetTypes.includes(someCsType)
export const cDocsChangeSetTypes = [
    ChangeSetType.C_FAILURE_REPORTING_ANALYSIS_CORRECTIVE_ACTION_SYSTEM_LINE_ITEM,
    ChangeSetType.C_TPS_LINE_ITEM,
    ChangeSetType.C_EASY_TRANSFER_LINE_ITEM,
    ChangeSetType.COSMIC_DOCUMENT_INITIALIZATION,
    ChangeSetType.WORK_ORDER_STEP,
    ChangeSetType.C_WORKFLOW_LINE_ITEM,
    ChangeSetType.C_RCA_LINE_ITEM
];
export const CosmicDocumentStatusDisplay = new Map([
    [CosmicDocumentStatus.AWAITING_CLOSURE_APPROVAL, 'Awaiting closure approval'],
    [CosmicDocumentStatus.BLOCKED, 'Blocked'],
    [CosmicDocumentStatus.CANCELLED, 'Cancelled'],
    [CosmicDocumentStatus.CLOSED, 'Closed'],
    [CosmicDocumentStatus.CLOSED_INCOMPLETE, 'Closed - Incomplete'],
    [CosmicDocumentStatus.DRAFT, 'Draft'],
    [CosmicDocumentStatus.OPEN, 'Open'],
    [CosmicDocumentStatus.PENDING, 'Pending'],
    [CosmicDocumentStatus.REMEDIAL_ACTIONS_COMPLETE, 'Remedial actions completed'],
    [CosmicDocumentStatus.REJECTED, 'Rejected'],
    [CosmicDocumentStatus.WORK_ORDER_STEP_REJECTED, 'Step(s) rejected'],
    [CosmicDocumentStatus.WORK_ORDER_STEPS_COMPLETE, 'Steps completed'],
    [CosmicDocumentStatus.WRITTEN_IN_ERROR, 'Written in error']
]);
// cNCR specific status display
export const CosmicNonconformanceReportStatusDisplay = new Map([
    [CosmicDocumentStatus.AWAITING_CLOSURE_APPROVAL, 'Awaiting closure approval'],
    [CosmicDocumentStatus.BLOCKED, 'Blocked'],
    [CosmicDocumentStatus.CLOSED, 'Closed'],
    [CosmicDocumentStatus.DRAFT, 'Draft'],
    [CosmicDocumentStatus.OPEN, 'Open'],
    [CosmicDocumentStatus.PENDING, 'Pending'],
    [CosmicDocumentStatus.REJECTED, 'Rejected'],
    [CosmicDocumentStatus.WORK_ORDER_STEP_REJECTED, 'Disposition rejected'],
    [CosmicDocumentStatus.WORK_ORDER_STEPS_COMPLETE, 'Disposition approved']
]);
// cNCR specific status display
export const CosmicNonconformanceReportStatusTooltipDisplay = new Map([
    [CosmicDocumentStatus.AWAITING_CLOSURE_APPROVAL, 'cNCR is awaiting final closure approval.'],
    [CosmicDocumentStatus.BLOCKED, 'cNCR has been BLOCKED by another Document.'],
    [
        CosmicDocumentStatus.CLOSED,
        'cNCR has been initialized. Final Disposition has been approved. Closure process completed.'
    ],
    [CosmicDocumentStatus.DRAFT, 'cNCR has been created but is not initialized.'],
    [CosmicDocumentStatus.OPEN, 'cNCR has been initialized. Await disposition and approvals.'],
    [CosmicDocumentStatus.PENDING, 'cNCR has an OPEN initialization.'],
    [CosmicDocumentStatus.REJECTED, 'cNCR has a REJECTED initialization.'],
    [CosmicDocumentStatus.WORK_ORDER_STEP_REJECTED, 'cDr has been rejected.'],
    [CosmicDocumentStatus.WORK_ORDER_STEPS_COMPLETE, 'Disposition has been approved and moved to Final Disposition.']
]);
export const CosmicDocumentStatusTooltipDisplay = new Map([
    [CosmicDocumentStatus.AWAITING_CLOSURE_APPROVAL, 'Document is awaiting closure approval.'],
    [CosmicDocumentStatus.BLOCKED, 'Document has be set to BLOCKED by an open cNCR.'],
    [CosmicDocumentStatus.CANCELLED, 'Document has been cancelled. Not all steps have been completed.'],
    [
        CosmicDocumentStatus.CLOSED,
        'Document has been initialized. All steps/tasks complete and no other open line items exist on this Document.'
    ],
    [CosmicDocumentStatus.CLOSED_INCOMPLETE, 'Document has been closed but not all steps were completed.'],
    [CosmicDocumentStatus.DRAFT, 'Document has been created but is not initialized.'],
    [CosmicDocumentStatus.OPEN, 'Document has been initialized. Document has at least 1 open step.'],
    [CosmicDocumentStatus.PENDING, 'Document has an OPEN initialization.'],
    [CosmicDocumentStatus.REJECTED, 'Document has a REJECTED initialization.'],
    [CosmicDocumentStatus.WORK_ORDER_STEP_REJECTED, 'At least 1 step has been rejected.'],
    [CosmicDocumentStatus.WORK_ORDER_STEPS_COMPLETE, 'All steps completed.'],
    [CosmicDocumentStatus.WRITTEN_IN_ERROR, 'Document has been written in error. No steps have been completed.']
]);
export const DocumentTypeDisplay = new Map([
    [DocumentType.ACCEPTANCE_DATA_PACK, 'ADP'],
    [DocumentType.BARCODE_DECLARATION, 'Barcode Declaration'],
    [DocumentType.C_NONCONFORMANCE_REPORT, 'cNCR'],
    [DocumentType.C_EASY_TRANSFER, 'cEZT'],
    [DocumentType.C_FAILURE_REPORTING_ANALYSIS_CORRECTIVE_ACTION_SYSTEM, 'cFRACAS'],
    [DocumentType.C_RCA, 'cRCA'],
    [DocumentType.C_DIGITAL_RECORD_REVIEW_ITEM, 'cRID'],
    [DocumentType.C_PROCEDURE, 'cPROC'],
    [DocumentType.C_TPS, 'cTPS'],
    [DocumentType.C_WORKFLOW, 'cWorkflow'],
    [DocumentType.CONFIGURATION_CHANGE_ORDER, 'CCO'],
    [DocumentType.CR, 'CR'],
    [DocumentType.DISCREPANCY_REPORT, 'DR'],
    [DocumentType.DELIVERY_ORDER, 'DO'],
    [DocumentType.DRAWING, 'Drawing'],
    [DocumentType.EASY_TRANSFER, 'EZT'],
    [DocumentType.ELABEL, 'e-LABEL'],
    [DocumentType.ELROD, 'e-LROD'],
    [DocumentType.ENGINEERING_CHANGE, 'EC'],
    [DocumentType.FAILURE_INVESTIGATION_ANOMALY_REPORT, 'FIAR'],
    [DocumentType.GCAR, 'GCAR'],
    [DocumentType.HAZARD_RESPONSE_LEVEL, 'HRL'],
    [DocumentType.IRREGULAR_PARTS_AUTHORIZATION_REQUEST, 'IPAR'],
    [DocumentType.ITEM_FOR_INVESTIGATION, 'IFI'],
    [DocumentType.MATERIAL_USAGE_AGREEMENT, 'MUA'],
    [DocumentType.NASA_SPACE_PART_AUTHORIZATION_REQUEST, 'NSPAR'],
    [DocumentType.NINE_ZERO_SIX, '906'],
    [DocumentType.OPS_NOM_DECLARATION, 'OPS NOM Declaration'],
    [DocumentType.OTHER_DOCUMENT, 'OD (Other Document)'],
    [DocumentType.OVER_DUE_TAG, 'ODT'],
    [DocumentType.PROBLEM_REPORTING_AND_CORRECTIVE_ACTION, 'PRACA'],
    [DocumentType.PROCEDURE, 'PROC'],
    [DocumentType.RSA, 'RSA'],
    [DocumentType.TPS, 'TPS'],
    [DocumentType.VEHICLE_CERTIFICATION, 'Vehicle Certification'],
    [DocumentType.WAIVER, 'Waiver'],
    [DocumentType.YELLOW_TAG_NOTICE, 'YTN']
]);
export const DocumentTypeLongDisplay = new Map([
    [DocumentType.ACCEPTANCE_DATA_PACK, 'Acceptance Data Pack'],
    [DocumentType.BARCODE_DECLARATION, 'Barcode Declaration'],
    [DocumentType.C_NONCONFORMANCE_REPORT, 'COSMIC Nonconformance Report'],
    [DocumentType.C_EASY_TRANSFER, 'COSMIC Easy Transfer'],
    [DocumentType.C_FAILURE_REPORTING_ANALYSIS_CORRECTIVE_ACTION_SYSTEM, 'cFRACAS'],
    [DocumentType.C_RCA, 'COSMIC Request for Corrective Action'],
    [DocumentType.C_DIGITAL_RECORD_REVIEW_ITEM, 'cRID'],
    [DocumentType.C_TPS, 'COSMIC Task Performance Sheet'],
    [DocumentType.C_WORKFLOW, 'COSMIC Workflow'],
    [DocumentType.CONFIGURATION_CHANGE_ORDER, 'Configuration Change Order'],
    [DocumentType.CR, 'Change Request'],
    [DocumentType.DISCREPANCY_REPORT, 'Non-COSMIC Nonconformance Report'],
    [DocumentType.DELIVERY_ORDER, 'Delivery Order'],
    [DocumentType.DRAWING, 'Drawing'],
    [DocumentType.EASY_TRANSFER, 'Non-COSMIC Easy Transfer'],
    [DocumentType.ELABEL, 'e-LABEL'],
    [DocumentType.ELROD, 'e-LROD'],
    [DocumentType.ENGINEERING_CHANGE, 'Engineering Change'],
    [DocumentType.FAILURE_INVESTIGATION_ANOMALY_REPORT, 'Failure Investigation Anomaly Report'],
    [DocumentType.GCAR, 'Government Certification Approval Request'],
    [DocumentType.HAZARD_RESPONSE_LEVEL, 'Hazard Response Level'],
    [DocumentType.IRREGULAR_PARTS_AUTHORIZATION_REQUEST, 'Irregular Parts Authorization Request'],
    [DocumentType.ITEM_FOR_INVESTIGATION, 'Item For Investigation'],
    [DocumentType.MATERIAL_USAGE_AGREEMENT, 'Material Usage Agreement'],
    [DocumentType.NASA_SPACE_PART_AUTHORIZATION_REQUEST, 'Nasa Space Part Authorization Request'],
    [DocumentType.NINE_ZERO_SIX, '906'],
    [DocumentType.OPS_NOM_DECLARATION, 'Operations Nomenclature Declaration'],
    [DocumentType.OTHER_DOCUMENT, 'Other Document'],
    [DocumentType.OVER_DUE_TAG, 'Over Due Tag'],
    [DocumentType.PROBLEM_REPORTING_AND_CORRECTIVE_ACTION, 'Problem Reporting And Corrective Action'],
    [DocumentType.PROCEDURE, 'Procedure'],
    [DocumentType.RSA, 'Rapid Spacecraft Acquisition'],
    [DocumentType.TPS, 'Non-COSMIC Task Performance Sheet'],
    [DocumentType.VEHICLE_CERTIFICATION, 'Vehicle Certification'],
    [DocumentType.WAIVER, 'Waiver'],
    [DocumentType.YELLOW_TAG_NOTICE, 'Yellow Tag Notice']
]);
export const DocumentRelationTypeDisplay = new Map([
    [DocumentRelationType.BLOCKED_DOCUMENT, 'Blocked Document'],
    [DocumentRelationType.FRACAS_DISCREPANCY_REPORT, 'cFRACAS Nonconformance Report'],
    [DocumentRelationType.OTHER, 'Other'],
    [DocumentRelationType.REFERENCE_DOCUMENT, 'Reference Document'],
    [DocumentRelationType.RID, 'RID'],
    // [DocumentRelationType.SOURCE_DOCUMENT, 'Source Document'],
    [DocumentRelationType.SPAWNED_DOCUMENT, 'Spawned Document']
]);
export var DocumentLineItemType;
(function (DocumentLineItemType) {
    DocumentLineItemType["CONFIGURATION_CHANGE_ORDER"] = "CONFIGURATION_CHANGE_ORDER";
    DocumentLineItemType["DISCREPANCY_REPORT"] = "DISCREPANCY_REPORT";
    DocumentLineItemType["EASY_TRANSFER"] = "EASY_TRANSFER";
    DocumentLineItemType["ENGINEERING_CHANGE"] = "ENGINEERING_CHANGE";
    DocumentLineItemType["FAILURE_INVESTIGATION_ANOMALY_REPORT"] = "FAILURE_INVESTIGATION_ANOMALY_REPORT";
    DocumentLineItemType["IRREGULAR_PARTS_AUTHORIZATION_REQUEST"] = "IRREGULAR_PARTS_AUTHORIZATION_REQUEST";
    DocumentLineItemType["ITEM_FOR_INVESTIGATION"] = "ITEM_FOR_INVESTIGATION";
    DocumentLineItemType["MATERIAL_USAGE_AGREEMENT"] = "MATERIAL_USAGE_AGREEMENT";
    DocumentLineItemType["NASA_SPACE_PART_AUTHORIZATION_REQUEST"] = "NASA_SPACE_PART_AUTHORIZATION_REQUEST";
    DocumentLineItemType["OTHER_DOCUMENT"] = "OTHER_DOCUMENT";
    DocumentLineItemType["OVER_DUE_TAG"] = "OVER_DUE_TAG";
    DocumentLineItemType["PROBLEM_REPORTING_AND_CORRECTIVE_ACTION"] = "PROBLEM_REPORTING_AND_CORRECTIVE_ACTION";
    DocumentLineItemType["PROCEDURE"] = "PROCEDURE";
    DocumentLineItemType["TPS"] = "TPS";
    DocumentLineItemType["WAIVER"] = "WAIVER";
    DocumentLineItemType["YELLOW_TAG_NOTICE"] = "YELLOW_TAG_NOTICE";
})(DocumentLineItemType || (DocumentLineItemType = {}));
export var DocumentTypesWithoutLineItems;
(function (DocumentTypesWithoutLineItems) {
    DocumentTypesWithoutLineItems["DRAWING"] = "DRAWING";
    DocumentTypesWithoutLineItems["PROCEDURE"] = "PROCEDURE";
})(DocumentTypesWithoutLineItems || (DocumentTypesWithoutLineItems = {}));
export const DocumentLineItemTypeDisplay = new Map([
    [DocumentLineItemType.CONFIGURATION_CHANGE_ORDER, 'CCO'],
    [DocumentLineItemType.DISCREPANCY_REPORT, 'DR'],
    [DocumentLineItemType.EASY_TRANSFER, 'EZT'],
    [DocumentLineItemType.ENGINEERING_CHANGE, 'EC'],
    [DocumentLineItemType.FAILURE_INVESTIGATION_ANOMALY_REPORT, 'FIAR'],
    [DocumentLineItemType.IRREGULAR_PARTS_AUTHORIZATION_REQUEST, 'IPAR'],
    [DocumentLineItemType.ITEM_FOR_INVESTIGATION, 'IFI'],
    [DocumentLineItemType.MATERIAL_USAGE_AGREEMENT, 'MUA'],
    [DocumentLineItemType.NASA_SPACE_PART_AUTHORIZATION_REQUEST, 'NSPAR'],
    [DocumentLineItemType.OTHER_DOCUMENT, 'OD'],
    [DocumentLineItemType.OVER_DUE_TAG, 'ODT'],
    [DocumentLineItemType.PROBLEM_REPORTING_AND_CORRECTIVE_ACTION, 'PRACA'],
    [DocumentLineItemType.PROCEDURE, 'PROC'],
    [DocumentLineItemType.TPS, 'TPS'],
    [DocumentLineItemType.WAIVER, 'WAIVER'],
    [DocumentLineItemType.YELLOW_TAG_NOTICE, 'YTN']
]);
export const DocumentTypesThatUseInitialization = [
    DocumentType.C_NONCONFORMANCE_REPORT,
    DocumentType.C_EASY_TRANSFER,
    DocumentType.C_FAILURE_REPORTING_ANALYSIS_CORRECTIVE_ACTION_SYSTEM,
    DocumentType.C_RCA,
    DocumentType.C_WORKFLOW,
    DocumentType.C_DIGITAL_RECORD_REVIEW_ITEM
];
export const DefaultDocumentAuthorityOverride = new Map([
    [DocumentType.C_NONCONFORMANCE_REPORT, 'cNCR_BUYOFF'],
    [DocumentType.C_TPS, 'cTPS_BUYOFF']
]);
export const DeliveryOrderLineItemStatusDisplay = new Map([
    [DeliveryOrderLineItemStatus.IN_PROCESS, 'In process'],
    [DeliveryOrderLineItemStatus.NOT_STARTED, 'Not started'],
    [DeliveryOrderLineItemStatus.PROBABLE, 'Probable'],
    [DeliveryOrderLineItemStatus.PROPOSAL, 'Proposal'],
    [DeliveryOrderLineItemStatus.VOID, 'Void'],
    [DeliveryOrderLineItemStatus.READY_FOR_COMPLETION, 'Ready for completion']
]);
export const DeliveryOrderLineItemTypeDisplay = new Map([
    [DeliveryOrderLineItemType.FL, 'Fleet leader'],
    [DeliveryOrderLineItemType.NEW_BUILD, 'New build'],
    [DeliveryOrderLineItemType.PROCURE, 'Procure'],
    [DeliveryOrderLineItemType.REFURB, 'Refurb']
]);
export var DocumentProcedureType;
(function (DocumentProcedureType) {
    DocumentProcedureType["ADV_EMU"] = "ADV_EMU";
    DocumentProcedureType["CIII"] = "CIII";
    DocumentProcedureType["CTSD"] = "CTSD";
    DocumentProcedureType["CTSDSH1263"] = "CTSDSH1263";
    DocumentProcedureType["CTSDSS1545"] = "CTSDSS1545";
    DocumentProcedureType["CTSDSS1637"] = "CTSDSS1637";
    DocumentProcedureType["GSE"] = "GSE";
    DocumentProcedureType["I"] = "I";
    DocumentProcedureType["II"] = "II";
    DocumentProcedureType["JSC"] = "JSC";
    DocumentProcedureType["LSS"] = "LSS";
    DocumentProcedureType["ORLAN"] = "ORLAN";
    DocumentProcedureType["RUS"] = "RUS";
    DocumentProcedureType["SP"] = "SP";
    DocumentProcedureType["SSA"] = "SSA";
    DocumentProcedureType["TBD"] = "TBD";
    DocumentProcedureType["WETF"] = "WETF";
})(DocumentProcedureType || (DocumentProcedureType = {}));
export const DocumentProcedureTypeDisplay = new Map([
    [DocumentProcedureType.ADV_EMU, 'ADV EMU'],
    [DocumentProcedureType.CIII, 'CIII'],
    [DocumentProcedureType.CTSD, 'CTSD'],
    [DocumentProcedureType.CTSDSH1263, 'CTSDSH1263'],
    [DocumentProcedureType.CTSDSS1545, 'CTSDSS1545'],
    [DocumentProcedureType.CTSDSS1637, 'CTSDSS1637'],
    [DocumentProcedureType.GSE, 'GSE'],
    [DocumentProcedureType.I, 'I'],
    [DocumentProcedureType.II, 'II'],
    [DocumentProcedureType.JSC, 'JSC'],
    [DocumentProcedureType.LSS, 'LSS'],
    [DocumentProcedureType.ORLAN, 'ORLAN'],
    [DocumentProcedureType.RUS, 'RUS'],
    [DocumentProcedureType.SP, 'SP'],
    [DocumentProcedureType.SSA, 'SSA'],
    [DocumentProcedureType.TBD, 'TBD'],
    [DocumentProcedureType.WETF, 'WETF']
]);
export const DocumentReleaseStatusDisplay = new Map([
    [DocumentReleaseStatus.AVAILABLE, 'Available'],
    [DocumentReleaseStatus.CANCELLED, 'Cancelled'],
    [DocumentReleaseStatus.IN_WORK, 'In Work'],
    [DocumentReleaseStatus.INACTIVE, 'Inactive'],
    [DocumentReleaseStatus.OBSOLETE, 'Obsolete'],
    [DocumentReleaseStatus.RELEASED, 'Released'],
    [DocumentReleaseStatus.UNKNOWN, 'Unknown']
]);
export const DocumentLineItemTypeToChangeSetType = new Map([
    [DocumentLineItemType.CONFIGURATION_CHANGE_ORDER, ChangeSetType.CONFIGURATION_CHANGE_ORDER_LINE_ITEM],
    [DocumentLineItemType.DISCREPANCY_REPORT, ChangeSetType.DISCREPANCY_REPORT_LINE_ITEM],
    [DocumentLineItemType.EASY_TRANSFER, ChangeSetType.EASY_TRANSFER_LINE_ITEM],
    [DocumentLineItemType.ENGINEERING_CHANGE, ChangeSetType.ENGINEERING_CHANGE_LINE_ITEM],
    [
        DocumentLineItemType.FAILURE_INVESTIGATION_ANOMALY_REPORT,
        ChangeSetType.FAILURE_INVESTIGATION_ANOMALY_REPORT_LINE_ITEM
    ],
    [
        DocumentLineItemType.IRREGULAR_PARTS_AUTHORIZATION_REQUEST,
        ChangeSetType.IRREGULAR_PARTS_AUTHORIZATION_REQUEST_LINE_ITEM
    ],
    [DocumentLineItemType.ITEM_FOR_INVESTIGATION, ChangeSetType.ITEM_FOR_INVESTIGATION_LINE_ITEM],
    [DocumentLineItemType.MATERIAL_USAGE_AGREEMENT, ChangeSetType.MATERIAL_USAGE_AGREEMENT_LINE_ITEM],
    [
        DocumentLineItemType.NASA_SPACE_PART_AUTHORIZATION_REQUEST,
        ChangeSetType.NASA_SPACE_PART_AUTHORIZATION_REQUEST_LINE_ITEM
    ],
    [DocumentLineItemType.OTHER_DOCUMENT, ChangeSetType.OTHER_DOCUMENT_LINE_ITEM],
    [DocumentLineItemType.OVER_DUE_TAG, ChangeSetType.OVER_DUE_TAG_LINE_ITEM],
    [
        DocumentLineItemType.PROBLEM_REPORTING_AND_CORRECTIVE_ACTION,
        ChangeSetType.PROBLEM_REPORTING_AND_CORRECTIVE_ACTION_LINE_ITEM
    ],
    [DocumentLineItemType.PROCEDURE, ChangeSetType.PROCEDURE_LINE_ITEM],
    [DocumentLineItemType.TPS, ChangeSetType.TPS_LINE_ITEM],
    [DocumentLineItemType.WAIVER, ChangeSetType.WAIVER_LINE_ITEM],
    [DocumentLineItemType.YELLOW_TAG_NOTICE, ChangeSetType.YELLOW_TAG_NOTICE_LINE_ITEM]
]);
export const EztDocumentTypeDisplay = new Map([
    [EztDocumentType.ISSUE, 'Issue'],
    [EztDocumentType.RECEIPT, 'Receipt'],
    [EztDocumentType.TRANSFER_ISSUED, 'Transfer as issued']
]);
export const FracasCauseOfFailureDisplay = new Map([
    [FracasCauseOfFailure.UNKNOWN, 'Unknown']
]);
export const FracasFailureModeDisplay = new Map([[FracasFailureMode.UNKNOWN, 'Unknown']]);
export const FracasFailureTypeDisplay = new Map([
    [FracasFailureType.ANOMALY, 'Anomaly'],
    [FracasFailureType.DISCREPANCY, 'Nonconformance'],
    [FracasFailureType.FAILURE, 'Failure'],
    [FracasFailureType.NON_CRITICAL, 'Non-Critical']
]);
export const FracasScoringDisplay = new Map([
    [FracasScoring.ESSENTIAL_FUNCTIONMISSION_CRITICAL, 'Essential function / Mission critical'],
    [FracasScoring.NON_ESSENTIAL_FUNCTION, 'Non-Essential function']
]);
export const FracasSubSystemDisplay = new Map([
    [FracasSubSystem.SOFTWARE, 'Software'],
    [FracasSubSystem.X_INFO, 'xINFO'],
    [FracasSubSystem.X_PGS, 'xPGS'],
    [FracasSubSystem.X_PLSS, 'xPLSS']
]);
export const FracasAnalysisStatusDisplay = new Map([
    [FracasAnalysisStatus.COMPLETE, 'Complete'],
    [FracasAnalysisStatus.IN_WORK, 'In-Work'],
    [FracasAnalysisStatus.NOT_STARTED, 'Not Started']
]);
export const FracasFailurePhaseDisplay = new Map([
    [FracasFailurePhase.INSPECTION, 'Inspection'],
    [FracasFailurePhase.ON_ORBIT, 'On-Orbit'],
    [FracasFailurePhase.TESTING, 'Testing']
]);
export const FracasFailureEnvironmentDisplay = new Map([
    [FracasFailureEnvironment.ACCEPTANCE_TESTING, 'Acceptance Testing'],
    [FracasFailureEnvironment.DVT_TESTING, 'DVT Testing'],
    [FracasFailureEnvironment.GATEWAY, 'Gateway'],
    [FracasFailureEnvironment.HLS, 'HLS'],
    [FracasFailureEnvironment.ISS, 'ISS'],
    [FracasFailureEnvironment.LUNAR, 'Lunar'],
    [FracasFailureEnvironment.QUALITY_TESTING, 'Quality Testing']
]);
export const TaskPerformanceSheetCriticalityDisplay = new Map([
    [TaskPerformanceSheetCriticality._1, '1: Loss of crew or vehicle'],
    [TaskPerformanceSheetCriticality._2, '2: Loss of mission'],
    [TaskPerformanceSheetCriticality._3, '3: No effect'],
    [TaskPerformanceSheetCriticality.N_A, 'Not applicable']
]);
export const TpsDocumentTypeDisplay = new Map([
    [TpsDocumentType.CONFIGURATION_CHANGE, 'Configuration Change'],
    [TpsDocumentType.FABRICATION, 'Fabrication'],
    [TpsDocumentType.ASSEMBLY, 'Assembly'],
    [TpsDocumentType.TEMPORARY_CONFIGURATION_CHANGE, 'Temporary Configuration Change'],
    [TpsDocumentType.DOWNGRADE_NON_DISCREPANT, 'Downgrade Non-Discrepant'],
    [TpsDocumentType.CLASSIFICATION, 'Classification'],
    [TpsDocumentType.ACTIVATION_INACTIVATION_OF_HARDWARE, 'Activation / Inactivation of Hardware'],
    [TpsDocumentType.OTHER_CONFIGURATION_CHANGE, 'Other Configuration Change'],
    [TpsDocumentType.MAINTENANCE, 'Maintenance'],
    [TpsDocumentType.ACCEPTANCE_TEST, 'Acceptance Test'],
    [TpsDocumentType.QUALIFICATION_CERTIFICATION_TEST, 'Qualification / Certificate Test'],
    [TpsDocumentType.TEST_CALIBRATION, 'Test Calibration'],
    [TpsDocumentType.ENGINEERING_EVALUATION, 'Engineering Evaluation'],
    [TpsDocumentType.TRANSFER_ROUND_ROBIN, 'Transfer Round Robin'],
    [TpsDocumentType.OTHER_NON_CONFIGURATION_CHANGE, 'Other Non-Configuration Change'],
    [TpsDocumentType.POST_FLIGHT_ACTIVITY, 'Post-Flight Activity'],
    [TpsDocumentType.FABRICATION_I_E, 'Fabrication IE'],
    [TpsDocumentType.I_E_PROJECT_WORK, 'IE Project Work'],
    [TpsDocumentType.SIX_ONE_ONE, '611']
]);
export const TpsClosureStatusDisplay = new Map([
    [TpsClosureStatus.CANCELLED, 'Cancelled'],
    [TpsClosureStatus.CLOSED_INCOMPLETE, 'Closed - Incomplete'],
    [TpsClosureStatus.CLOSED, 'Closed'],
    [TpsClosureStatus.WRITTEN_IN_ERROR, 'Written in error']
]);
export var RcaAwardFeePeriod;
(function (RcaAwardFeePeriod) {
    RcaAwardFeePeriod["AFP_2_WEAKNESS"] = "AFP_2_WEAKNESS";
    RcaAwardFeePeriod["AFP_3_FIRST_QTR_AOI"] = "AFP_3_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_3_MIDTERM"] = "AFP_3_MIDTERM";
    RcaAwardFeePeriod["AFP_3_THIRD_QTR_AOI"] = "AFP_3_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_3_WEAKNESS"] = "AFP_3_WEAKNESS";
    RcaAwardFeePeriod["AFP_4_FIRST_QTR_AOI"] = "AFP_4_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_4_MIDTERM"] = "AFP_4_MIDTERM";
    RcaAwardFeePeriod["AFP_4_THIRD_QTR_AOI"] = "AFP_4_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_4_WEAKNESS"] = "AFP_4_WEAKNESS";
    RcaAwardFeePeriod["AFP_5_MIDTERM"] = "AFP_5_MIDTERM";
    RcaAwardFeePeriod["AFP_5_THIRD_QTR_AOI"] = "AFP_5_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_5_WEAKNESS"] = "AFP_5_WEAKNESS";
    RcaAwardFeePeriod["AFP_5_FIRST_QTR_AOI"] = "AFP_5_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_6_WEAKNESS"] = "AFP_6_WEAKNESS";
    RcaAwardFeePeriod["AFP_6_MIDTERM"] = "AFP_6_MIDTERM";
    RcaAwardFeePeriod["AFP_6_THIRD_QTR_AOI"] = "AFP_6_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_6_FIRST_QTR_AOI"] = "AFP_6_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_7_WEAKNESS"] = "AFP_7_WEAKNESS";
    RcaAwardFeePeriod["AFP_7_FIRST_QTR_AOI"] = "AFP_7_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_7_MIDTERM"] = "AFP_7_MIDTERM";
    RcaAwardFeePeriod["AFP_7_THIRD_QTR_AOI"] = "AFP_7_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_8_WEAKNESS"] = "AFP_8_WEAKNESS";
    RcaAwardFeePeriod["AFP_8_FIRST_QTR_AOI"] = "AFP_8_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_8_MIDTERM"] = "AFP_8_MIDTERM";
    RcaAwardFeePeriod["AFP_8_THIRD_QTR_AOI"] = "AFP_8_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_9_WEAKNESS"] = "AFP_9_WEAKNESS";
    RcaAwardFeePeriod["AFP_9_FIRST_QTR_AOI"] = "AFP_9_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_9_MIDTERM"] = "AFP_9_MIDTERM";
    RcaAwardFeePeriod["AFP_9_THIRD_QTR_AOI"] = "AFP_9_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_10_WEAKNESS"] = "AFP_10_WEAKNESS";
    RcaAwardFeePeriod["AFP_10_FIRST_QTR_AOI"] = "AFP_10_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_10_MIDTERM"] = "AFP_10_MIDTERM";
    RcaAwardFeePeriod["AFP_10_THIRD_QTR_AOI"] = "AFP_10_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_11_WEAKNESS"] = "AFP_11_WEAKNESS";
    RcaAwardFeePeriod["AFP_11_FIRST_QTR_AOI"] = "AFP_11_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_11_MIDTERM"] = "AFP_11_MIDTERM";
    RcaAwardFeePeriod["AFP_11_THIRD_QTR_AOI"] = "AFP_11_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_12_WEAKNESS"] = "AFP_12_WEAKNESS";
    RcaAwardFeePeriod["AFP_12_FIRST_QTR_AOI"] = "AFP_12_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_12_MIDTERM"] = "AFP_12_MIDTERM";
    RcaAwardFeePeriod["AFP_12_THIRD_QTR_AOI"] = "AFP_12_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_13_FIRST_QTR_AOI"] = "AFP_13_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_13_WEAKNESS"] = "AFP_13_WEAKNESS";
    RcaAwardFeePeriod["AFP_13_MIDTERM"] = "AFP_13_MIDTERM";
    RcaAwardFeePeriod["AFP_13_THIRD_QTR_AOI"] = "AFP_13_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_14_WEAKNESS"] = "AFP_14_WEAKNESS";
    RcaAwardFeePeriod["AFP_14_FIRST_QTR_AOI"] = "AFP_14_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_14_MIDTERM"] = "AFP_14_MIDTERM";
    RcaAwardFeePeriod["AFP_14_THIRD_QTR_AOI"] = "AFP_14_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_15_WEAKNESS"] = "AFP_15_WEAKNESS";
    RcaAwardFeePeriod["AFP_15_FIRST_QTR_AOI"] = "AFP_15_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_15_MIDTERM"] = "AFP_15_MIDTERM";
    RcaAwardFeePeriod["AFP_15_THIRD_QTR_AOI"] = "AFP_15_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_16_WEAKNESS"] = "AFP_16_WEAKNESS";
    RcaAwardFeePeriod["AFP_16_FIRST_QTR_AOI"] = "AFP_16_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_16_MIDTERM"] = "AFP_16_MIDTERM";
    RcaAwardFeePeriod["AFP_16_THIRD_QTR_AOI"] = "AFP_16_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_17_WEAKNESS"] = "AFP_17_WEAKNESS";
    RcaAwardFeePeriod["AFP_17_FIRST_QTR_AOI"] = "AFP_17_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_17_MIDTERM"] = "AFP_17_MIDTERM";
    RcaAwardFeePeriod["AFP_17_THIRD_QTR_AOI"] = "AFP_17_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_18_WEAKNESS"] = "AFP_18_WEAKNESS";
    RcaAwardFeePeriod["AFP_18_FIRST_QTR_AOI"] = "AFP_18_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_18_MIDTERM"] = "AFP_18_MIDTERM";
    RcaAwardFeePeriod["AFP_18_THIRD_QTR_AOI"] = "AFP_18_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_19_WEAKNESS"] = "AFP_19_WEAKNESS";
    RcaAwardFeePeriod["AFP_19_FIRST_QTR_AOI"] = "AFP_19_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_19_MIDTERM"] = "AFP_19_MIDTERM";
    RcaAwardFeePeriod["AFP_19_THIRD_QTR_AOI"] = "AFP_19_THIRD_QTR_AOI";
    RcaAwardFeePeriod["AFP_20_WEAKNESS"] = "AFP_20_WEAKNESS";
    RcaAwardFeePeriod["AFP_20_FIRST_QTR_AOI"] = "AFP_20_FIRST_QTR_AOI";
    RcaAwardFeePeriod["AFP_20_MIDTERM"] = "AFP_20_MIDTERM";
    RcaAwardFeePeriod["AFP_20_THIRD_QTR_AOI"] = "AFP_20_THIRD_QTR_AOI";
})(RcaAwardFeePeriod || (RcaAwardFeePeriod = {}));
export const RcaAwardFeePeriodDisplay = new Map([
    [RcaAwardFeePeriod.AFP_2_WEAKNESS, 'AFP 2 Weakness'],
    [RcaAwardFeePeriod.AFP_3_FIRST_QTR_AOI, 'AFP 3 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_3_MIDTERM, 'AFP 3 Midterm'],
    [RcaAwardFeePeriod.AFP_3_THIRD_QTR_AOI, 'AFP 3 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_3_WEAKNESS, 'AFP 3 Weakness'],
    [RcaAwardFeePeriod.AFP_4_FIRST_QTR_AOI, 'AFP 4 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_4_MIDTERM, 'AFP 4 Midterm'],
    [RcaAwardFeePeriod.AFP_4_THIRD_QTR_AOI, 'AFP 4 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_4_WEAKNESS, 'AFP 4 Weakness'],
    [RcaAwardFeePeriod.AFP_5_FIRST_QTR_AOI, 'AFP 5 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_5_MIDTERM, 'AFP 5 Midterm'],
    [RcaAwardFeePeriod.AFP_5_THIRD_QTR_AOI, 'AFP 5 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_5_WEAKNESS, 'AFP 5 Weakness'],
    [RcaAwardFeePeriod.AFP_6_FIRST_QTR_AOI, 'AFP 6 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_6_MIDTERM, 'AFP 6 Midterm'],
    [RcaAwardFeePeriod.AFP_6_THIRD_QTR_AOI, 'AFP 6 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_6_WEAKNESS, 'AFP 6 Weakness'],
    [RcaAwardFeePeriod.AFP_7_FIRST_QTR_AOI, 'AFP 7 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_7_MIDTERM, 'AFP 7 Midterm'],
    [RcaAwardFeePeriod.AFP_7_THIRD_QTR_AOI, 'AFP 7 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_7_WEAKNESS, 'AFP 7 Weakness'],
    [RcaAwardFeePeriod.AFP_8_FIRST_QTR_AOI, 'AFP 8 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_8_MIDTERM, 'AFP 8 Midterm'],
    [RcaAwardFeePeriod.AFP_8_THIRD_QTR_AOI, 'AFP 8 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_8_WEAKNESS, 'AFP 8 Weakness'],
    [RcaAwardFeePeriod.AFP_9_FIRST_QTR_AOI, 'AFP 9 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_9_MIDTERM, 'AFP 9 Midterm'],
    [RcaAwardFeePeriod.AFP_9_THIRD_QTR_AOI, 'AFP 9 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_9_WEAKNESS, 'AFP 9 Weakness'],
    [RcaAwardFeePeriod.AFP_10_FIRST_QTR_AOI, 'AFP 10 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_10_MIDTERM, 'AFP 10 Midterm'],
    [RcaAwardFeePeriod.AFP_10_THIRD_QTR_AOI, 'AFP 10 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_10_WEAKNESS, 'AFP 10 Weakness'],
    [RcaAwardFeePeriod.AFP_11_FIRST_QTR_AOI, 'AFP 11 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_11_MIDTERM, 'AFP 11 Midterm'],
    [RcaAwardFeePeriod.AFP_11_THIRD_QTR_AOI, 'AFP 11 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_11_WEAKNESS, 'AFP 11 Weakness'],
    [RcaAwardFeePeriod.AFP_12_FIRST_QTR_AOI, 'AFP 12 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_12_MIDTERM, 'AFP 12 Midterm'],
    [RcaAwardFeePeriod.AFP_12_THIRD_QTR_AOI, 'AFP 12 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_12_WEAKNESS, 'AFP 12 Weakness'],
    [RcaAwardFeePeriod.AFP_13_FIRST_QTR_AOI, 'AFP 13 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_13_MIDTERM, 'AFP 13 Midterm'],
    [RcaAwardFeePeriod.AFP_13_THIRD_QTR_AOI, 'AFP 13 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_13_WEAKNESS, 'AFP 13 Weakness'],
    [RcaAwardFeePeriod.AFP_14_FIRST_QTR_AOI, 'AFP 14 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_14_MIDTERM, 'AFP 14 Midterm'],
    [RcaAwardFeePeriod.AFP_14_THIRD_QTR_AOI, 'AFP 14 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_14_WEAKNESS, 'AFP 14 Weakness'],
    [RcaAwardFeePeriod.AFP_15_FIRST_QTR_AOI, 'AFP 15 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_15_MIDTERM, 'AFP 15 Midterm'],
    [RcaAwardFeePeriod.AFP_15_THIRD_QTR_AOI, 'AFP 15 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_15_WEAKNESS, 'AFP 15 Weakness'],
    [RcaAwardFeePeriod.AFP_16_FIRST_QTR_AOI, 'AFP 16 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_16_MIDTERM, 'AFP 16 Midterm'],
    [RcaAwardFeePeriod.AFP_16_THIRD_QTR_AOI, 'AFP 16 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_16_WEAKNESS, 'AFP 16 Weakness'],
    [RcaAwardFeePeriod.AFP_17_FIRST_QTR_AOI, 'AFP 17 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_17_MIDTERM, 'AFP 17 Midterm'],
    [RcaAwardFeePeriod.AFP_17_THIRD_QTR_AOI, 'AFP 17 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_17_WEAKNESS, 'AFP 17 Weakness'],
    [RcaAwardFeePeriod.AFP_18_FIRST_QTR_AOI, 'AFP 18 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_18_MIDTERM, 'AFP 18 Midterm'],
    [RcaAwardFeePeriod.AFP_18_THIRD_QTR_AOI, 'AFP 18 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_18_WEAKNESS, 'AFP 18 Weakness'],
    [RcaAwardFeePeriod.AFP_19_FIRST_QTR_AOI, 'AFP 19 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_19_MIDTERM, 'AFP 19 Midterm'],
    [RcaAwardFeePeriod.AFP_19_THIRD_QTR_AOI, 'AFP 19 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_19_WEAKNESS, 'AFP 19 Weakness'],
    [RcaAwardFeePeriod.AFP_20_FIRST_QTR_AOI, 'AFP 20 First QTR AOI'],
    [RcaAwardFeePeriod.AFP_20_MIDTERM, 'AFP 20 Midterm'],
    [RcaAwardFeePeriod.AFP_20_THIRD_QTR_AOI, 'AFP 20 Third QTR AOI'],
    [RcaAwardFeePeriod.AFP_20_WEAKNESS, 'AFP 20 Weakness']
]);
export const RcaRootCauseCategoryDisplay = new Map([
    [
        RcaRootCauseCategory.CUSTOMER_INITIATED_SCHEDULE_PRESSURE_ADDITIONAL_SCOPE,
        'Customer initiated schedule pressure additional scope'
    ],
    [RcaRootCauseCategory.ERROR_IN_PROCEDURE, 'Error in procedure'],
    [RcaRootCauseCategory.HUMAN_ERROR, 'Human error'],
    [
        RcaRootCauseCategory.LACK_OF_A_DEFINED_SCOPE_OR_POOR_UNDERSTANDING_OF_SCOPE,
        'Lack of a defined scope or poor understanding of scope'
    ],
    [RcaRootCauseCategory.LACK_OF_DOCUMENTED_PROCEDURE, 'Lack of documented procedure'],
    [RcaRootCauseCategory.LACK_OF_MAINTENANCE_UPKEEP, 'Lack of maintenance upkeep'],
    [RcaRootCauseCategory.LACK_OF_TRAINING_OR_MENTORSHIP, 'Lack of training or mentorship'],
    [RcaRootCauseCategory.PERSONAL_WARRANTY_VIOLATION, 'Personal warranty violation'],
    [RcaRootCauseCategory.POOR_ASSEMBLY_TEST_OF_PRODUCT, 'Poor assembly test of product'],
    [RcaRootCauseCategory.POOR_COMMUNICATION_AMONG_STAKEHOLDERS_TEAM, 'Poor communication among stakeholders team'],
    [RcaRootCauseCategory.POOR_ENGINEERING_OR_DESIGN, 'Poor engineering or design'],
    [RcaRootCauseCategory.POOR_INSPECTION_OF_FINAL_PRODUCT, 'Poor inspection of final product'],
    [RcaRootCauseCategory.POOR_PROJECT_MANAGEMENT, 'Poor project management']
]);
export const WorkOrderStepCompletionStatusDisplay = new Map([
    [WorkOrderStepCompletionStatus.WORKED, 'Worked'],
    [WorkOrderStepCompletionStatus.NOT_PERFORMED, 'Not performed'],
    [WorkOrderStepCompletionStatus.NOT_APPLICABLE, 'Not applicable']
]);
export var MandatoryInspectionPointType;
(function (MandatoryInspectionPointType) {
    MandatoryInspectionPointType["MIP-V"] = "MIP-V";
    MandatoryInspectionPointType["MIP-W"] = "MIP-W";
    MandatoryInspectionPointType["GMIP-V"] = "GMIP-V";
    MandatoryInspectionPointType["GMIP-W"] = "GMIP-W";
    MandatoryInspectionPointType["GMIP-I"] = "GMIP-I";
    MandatoryInspectionPointType["MIP-As noted"] = "MIP-As noted";
})(MandatoryInspectionPointType || (MandatoryInspectionPointType = {}));
export const HistoryTypeDisplay = new Map([
    [HistoryType.ACTIVITY_CREATED, 'Activity created'],
    [HistoryType.ACTIVITY_DELETED, 'Activity deleted'],
    [HistoryType.ACTIVITY_MODIFIED, 'Activity modified'],
    [HistoryType.ATTACHMENT_ADDED, 'Attachment added'],
    [HistoryType.ATTACHMENT_REMOVED, 'Attachment removed'],
    [HistoryType.CHANGE_SET_APPROVED, 'Change set approved'],
    [HistoryType.CHANGE_SET_AUTHORITY_APPROVED, 'Approval approved'],
    [HistoryType.CHANGE_SET_AUTHORITY_CREATED, 'Approval created'],
    [HistoryType.CHANGE_SET_AUTHORITY_DELETED, 'Approval deleted'],
    [HistoryType.CHANGE_SET_AUTHORITY_REJECTED, 'Approval rejected'],
    [HistoryType.CHANGE_SET_AUTO_APPROVED, 'Change set auto approved'],
    [HistoryType.CHANGE_SET_CREATED, 'Change set created'],
    [HistoryType.CHANGE_SET_DELETED, 'Change set deleted'],
    [HistoryType.CHANGE_SET_REJECTED, 'Change set rejected'],
    [HistoryType.CHANGE_SET_REOPENED, 'Change set reopened'],
    [HistoryType.COMMENT_CREATED, 'Comment created'],
    [HistoryType.COMMENT_DELETED, 'Comment deleted'],
    [HistoryType.COMMENT_MODIFIED, 'Comment modified'],
    [HistoryType.DOCUMENT_CLOSED, 'Document closed'],
    [HistoryType.DOCUMENT_CLOSURE_AUTO_APPROVED, 'Document closure auto approved'],
    [HistoryType.DOCUMENT_CLOSURE_CREATED, 'Document closure created'],
    [HistoryType.DOCUMENT_CLOSURE_REJECTED, 'Document closure rejected'],
    [HistoryType.DOCUMENT_CREATED, 'Document created'],
    [HistoryType.DOCUMENT_INITIALIZATION_AUTO_APPROVED, 'Document initialization auto approved'],
    [HistoryType.DOCUMENT_INITIALIZATION_CREATED, 'Document start initiated'],
    [HistoryType.DOCUMENT_INITIALIZATION_REJECTED, 'Document initialization rejected'],
    [HistoryType.DOCUMENT_INITIALIZED, 'Document initialized'],
    [HistoryType.DOCUMENT_MODIFIED, 'Document modified'],
    [HistoryType.DOCUMENT_RELATIONSHIP_CREATED, 'COSMIC connection created'],
    [HistoryType.DOCUMENT_RELATIONSHIP_DELETED, 'COSMIC connection deleted'],
    [HistoryType.HARDWARE_LIST_PART_CREATED, 'Part added to list'],
    [HistoryType.HARDWARE_LIST_PART_DELETED, 'Part removed from list'],
    [HistoryType.HARDWARE_LIST_PART_MODIFIED, 'Part updated on list'],
    [HistoryType.INVENTORY_AUDIT_CORRECTION, 'Inventory audit correction'],
    [HistoryType.INVENTORY_AUDIT_VERIFICATION, 'Inventory audit verification'],
    [HistoryType.INVENTORY_CHANGE_SET_APPROVED, 'Inventory change set approved'],
    [HistoryType.INVENTORY_CHANGE_SET_AUTO_APPROVED, 'Inventory change set auto approved'],
    [HistoryType.INVENTORY_CHILD_INSTALLED, 'Inventory child installed'],
    [HistoryType.INVENTORY_CHILD_REMOVED, 'Inventory child removed'],
    [HistoryType.INVENTORY_INSTALLED_ONTO_PARENT, 'Inventory installed onto parent'],
    [HistoryType.INVENTORY_ISSUED, 'Inventory issued'],
    [HistoryType.INVENTORY_MODIFIED, 'Inventory modified'],
    [HistoryType.INVENTORY_MOVED, 'Inventory moved'],
    [HistoryType.INVENTORY_QUOTA_CREATED, 'Inventory quota created'],
    [HistoryType.INVENTORY_QUOTA_DELETED, 'Inventory quota deleted'],
    [HistoryType.INVENTORY_QUOTA_MODIFIED, 'Inventory quota modified'],
    [HistoryType.INVENTORY_RECEIVED, 'Inventory received'],
    [HistoryType.INVENTORY_SERIALIZED, 'Inventory serialized'],
    [HistoryType.INVENTORY_UNINSTALLED_FROM_PARENT, 'Inventory uninstalled from parent'],
    [HistoryType.ITEM_DRAWING_CHANGE_SET_APPROVED, 'Item Drawing change set approved'],
    [HistoryType.ITEM_DRAWING_CHANGE_SET_AUTO_APPROVED, 'Item Drawing change set auto approved'],
    [HistoryType.ITEM_DRAWING_CREATED, 'Item Drawing created'],
    [HistoryType.ITEM_DRAWING_MODIFIED, 'Item Drawing modified'],
    [HistoryType.ITEM_INSTANCE_CALIBRATION_QUOTA_CREATED, 'Item Instance calibration quota created'],
    [HistoryType.ITEM_INSTANCE_CALIBRATION_QUOTA_DELETED, 'Item Instance calibration quota deleted'],
    [HistoryType.ITEM_INSTANCE_CALIBRATION_QUOTA_MODIFIED, 'Item Instance calibration quota modified'],
    [HistoryType.ITEM_INSTANCE_CHANGE_SET_APPROVED, 'Item Instance change set approved'],
    [HistoryType.ITEM_INSTANCE_CHANGE_SET_AUTO_APPROVED, 'Item Instance change set auto approved'],
    [HistoryType.ITEM_INSTANCE_CREATED, 'Item Instance created'],
    [HistoryType.ITEM_INSTANCE_LIMITED_LIFE_CREATED, 'Item Instance limited life created'],
    [HistoryType.ITEM_INSTANCE_LIMITED_LIFE_DELETED, 'Item Instance limited life deleted'],
    [HistoryType.ITEM_INSTANCE_LIMITED_LIFE_MODIFIED, 'Item Instance limited life modified'],
    [HistoryType.ITEM_INSTANCE_MODIFIED, 'Item Instance modified'],
    [HistoryType.ITEM_MASTER_CALIBRATION_QUOTA_CREATED, 'Item Master calibration quota created'],
    [HistoryType.ITEM_MASTER_CALIBRATION_QUOTA_DELETED, 'Item Master calibration quota deleted'],
    [HistoryType.ITEM_MASTER_CALIBRATION_QUOTA_MODIFIED, 'Item Master calibration quota modified'],
    [HistoryType.ITEM_MASTER_CHANGE_SET_APPROVED, 'Item Master change set approved'],
    [HistoryType.ITEM_MASTER_CHANGE_SET_AUTO_APPROVED, 'Item Master change set auto approved'],
    [HistoryType.ITEM_MASTER_CREATED, 'Item Master created'],
    [HistoryType.ITEM_MASTER_INITIALIZED, 'Item Master initialized'],
    [HistoryType.ITEM_MASTER_LIMITED_LIFE_CREATED, 'Item Master limited life created'],
    [HistoryType.ITEM_MASTER_LIMITED_LIFE_DELETED, 'Item Master limited life deleted'],
    [HistoryType.ITEM_MASTER_LIMITED_LIFE_MODIFIED, 'Item Master limited life modified'],
    [HistoryType.ITEM_MASTER_MODIFIED, 'Item Master modified'],
    [HistoryType.LINK_CREATED, 'Link created'],
    [HistoryType.LINK_DELETED, 'Link deleted'],
    [HistoryType.LINK_MODIFIED, 'Link modified'],
    [HistoryType.NONCONFORMANCE_REPORT_CREATED, 'cNCR created'],
    [HistoryType.NONCONFORMANCE_REPORT_MODIFIED, 'cNCR modified'],
    [HistoryType.NONCONFORMANCE_REPORT_LINE_ITEM_CREATED, 'NCA added to cNCR'],
    [HistoryType.NONCONFORMANCE_REPORT_LINE_ITEM_DELETED, 'NCA deleted from cNCR'],
    [HistoryType.NONCONFORMANCE_REPORT_LINE_ITEM_MODIFIED, 'NCA modified'],
    [HistoryType.PROCEDURE_CREATED, 'cProc created'],
    [HistoryType.PROCEDURE_MODIFIED, 'cProc modified'],
    [HistoryType.REQUEST_FOR_CORRECTIVE_ACTION_CREATED, 'Request for corrective action created'],
    [HistoryType.REQUEST_FOR_CORRECTIVE_ACTION_MODIFIED, 'Request for corrective action modified'],
    [HistoryType.RESPONSIBLE_ORGANIZATION_CREATED, 'Responsible organization created'],
    [HistoryType.RESPONSIBLE_ORGANIZATION_DELETED, 'Responsible organization deleted'],
    [HistoryType.RESPONSIBLE_ORGANIZATION_MODIFIED, 'Responsible organization modified'],
    [HistoryType.REVIEW_BOARD_CREATED, 'Review board decision created'],
    [HistoryType.REVIEW_BOARD_DELETED, 'Review board decision deleted'],
    [HistoryType.SERIALIZED_INVENTORY_CREATED, 'Serialized Inventory created'],
    [HistoryType.TASK_PERFORMANCE_SHEET_CREATED, 'cTPS created'],
    [HistoryType.TASK_PERFORMANCE_SHEET_MODIFIED, 'cTPS modified'],
    [HistoryType.USER_GROUP_CREATED, 'User group created'],
    [HistoryType.USER_GROUP_MEMBER_ADDED, 'User group member added'],
    [HistoryType.USER_GROUP_MEMBER_REMOVED, 'User group member removed'],
    [HistoryType.USER_GROUP_MODIFIED, 'User group modified'],
    [HistoryType.WORKFLOW_CREATED, 'Workflow created'],
    [HistoryType.WORKFLOW_MODIFIED, 'Workflow modified'],
    [HistoryType.WORK_ORDER_STEP_AUTO_CLOSED, 'Step auto closed'],
    [HistoryType.WORK_ORDER_STEP_CLOSED, 'Step closed'],
    [HistoryType.WORK_ORDER_STEP_CLOSURE_CREATED, 'Step closure created'],
    [HistoryType.WORK_ORDER_STEP_CLOSURE_REJECTED, 'Step closure rejected'],
    [HistoryType.WORK_ORDER_STEP_CREATED, 'Step created'],
    [HistoryType.WORK_ORDER_STEP_DELETED, 'Step deleted'],
    [HistoryType.WORK_ORDER_STEP_FORM_FIELD_CREATED, 'Step metadata created'],
    [HistoryType.WORK_ORDER_STEP_FORM_FIELD_DELETED, 'Step metadata deleted'],
    [HistoryType.WORK_ORDER_STEP_FORM_FIELD_MODIFIED, 'Step metadata modified'],
    [HistoryType.WORK_ORDER_STEP_MODIFIED, 'Step modified']
]);
